import { render } from "./CardButton.vue?vue&type=template&id=90daf1ec&scoped=true"
import script from "./CardButton.vue?vue&type=script&lang=js"
export * from "./CardButton.vue?vue&type=script&lang=js"

import "./CardButton.vue?vue&type=style&index=0&id=90daf1ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90daf1ec"]])

export default __exports__